import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { BannerCheckBox, Button, PreviewAdsImage } from "../../../components";
import { withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Store } from "react-notifications-component";
import WebBannerUploader from "../../../components/webBannerUploader";
import { setNewAdvertisement } from "../../AdsCampaign/redux/actions";

const AdvWebImageUploader = (props) => {
  const dispatch = useDispatch();

  const [banner, setBanner] = useState(false);
  const [selectBocError, setSelectBocError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [previewImages, setPreviewImages] = useState([]);
  const [previewImagesRight, setPreviewImagesRight] = useState([]);
  const [bannerImage, setBannerImage] = useState(null);
  const [gifImageRight, setGifImageRight] = useState(null);
  const [gifImage, setGifImage] = useState(null);
  const [logoImage, setLogoImage] = useState("");

  const [formData, setFormData] = useState({
    destinationURL: {
      key: "destinationURL",
      label: "Destination URL",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
        url: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    title: {
      key: "title",
      label: "Title",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    description: {
      key: "description",
      label: "Description",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    buttonType: {
      key: "buttonType",
      label: "Button Type",
      size: "sm",
      placeholder: "-",
      mainLayerStyles: " flex-column " + " align-content-center ",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [
          {
            key: "More",
            displayValue: "More",
          },
          {
            key: "Learn More",
            displayValue: "Learn More",
          },
          {
            key: "Click",
            displayValue: "Click",
          },
          {
            key: "Visit",
            displayValue: "Visit",
          },
        ],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const { advertisement } = useSelector(
    ({ adsCampaignReducer }) => adsCampaignReducer
  );

  const [adSpaceType, setAdSpaceType] = useState({
    header: false,
    right: false,
  });

  const handleImage = (list) => {
    if (list?.length > 0) {
      setPreviewImages(list);
    } else {
      setPreviewImages([]);
    }
  };

  const handleImageRight = (list) => {
    if (list?.length > 0) {
      setPreviewImagesRight(list);
    } else {
      setPreviewImagesRight([]);
    }
  };

  const handleBannerImage = (image) => {
    setBannerImage(image);
  };

  const handleLogo = (image) => {
    setLogoImage(image);
  };

  const handleGif = (image) => {
    setGifImage(image);
  };

  const handleGifRight = (image) => {
    setGifImageRight(image);
  };

  const handleTab = (tab) => {
    if (tab) {
      setBanner(tab);
    }
  };

  const onChangeUrl = (form) => {
    if (form) {
      setFormData({
        ...formData,
        destinationURL: form.destinationURL,
        title: form.title,
        description: form.description,
        buttonType: form.buttonType,
      });
      // setFinish(false);
    }
  };

  useEffect(() => {
    // ad_space: adSpaceType,
    // header_banner_img: previewImages,
    // right_banner_img: previewImagesRight,
    // text_banner_logo: logoImage?.url,
    // text_banner_img: bannerImage ? [bannerImage] : [],
    // header_gif: gifImage ? [gifImage] : [],
    // right_gif: gifImageRight ? [gifImageRight] : [],
    // title: updateForm.title.value,
    // description: updateForm.description.value,
    // button_type: updateForm.buttonType.value,
    // web_ur
    const newFormData = { ...formData };

    if (advertisement?.ad_space) {
      setAdSpaceType(advertisement?.ad_space);
    }
    if (advertisement?.header_banner_img?.length > 0) {
      setPreviewImages(advertisement?.header_banner_img);
    }
    if (advertisement?.right_banner_img?.length > 0) {
      setPreviewImagesRight(advertisement?.right_banner_img);
    }
    if (advertisement?.text_banner_logo !== "") {
      setLogoImage(advertisement?.text_banner_logo);
    }
    if (advertisement?.text_banner_img?.length > 0) {
      setBannerImage(advertisement?.text_banner_img);
    }
    if (advertisement?.header_gif?.length > 0) {
      setGifImage(advertisement?.header_gif?.[0]);
    }
    if (advertisement?.right_gif?.length > 0) {
      setGifImageRight(advertisement?.right_gif?.[0]);
    }
    if (advertisement?.web_url !== "") {
      newFormData["destinationURL"].value = advertisement?.web_url;
    }

    if (advertisement?.title !== "") {
      newFormData["title"].value = advertisement?.title;
    }
    if (advertisement?.description !== "") {
      newFormData["description"].value = advertisement?.description;
    }
    if (advertisement?.button_type !== "") {
      newFormData["buttonType"].value = advertisement?.button_type;
    }
    setFormData(newFormData);
  }, [advertisement]);

  // const dispatch = useDispatch();
  const updateForm = { ...formData };

  return (
    <>
      <div className=" d-flex flex-row justify-content-between ">
        <div className="col-9 abiw-body-left-wrapper">
          <div className={"abiw__title"}>Choose Where Your Ad Will Appear</div>
          <div className={"abiw__subtitle"}>
            Choose where the ad will appear across the platform.
          </div>
          <div className="abiw-header-wrapper">
            <BannerCheckBox
              data={{
                checkName: "Web site header banner",
                isActive: adSpaceType.header,
                type: "header",
                error: selectBocError,
              }}
              onClick={() => {
                setSelectBocError(false);
                setAdSpaceType((prev) => ({
                  ...prev,
                  header: !prev.header,
                }));
              }}
            />
            <BannerCheckBox
              data={{
                checkName: "Web site slider banner",
                isActive: adSpaceType.right,
                type: "slider",
                error: selectBocError,
              }}
              onClick={() => {
                setSelectBocError(false);
                setAdSpaceType((prev) => ({
                  ...prev,
                  right: !prev.right,
                }));
              }}
            />
          </div>
          {adSpaceType.header && (
            <div className={"abiw__form "}>
              <WebBannerUploader
                data={{
                  title: "Upload Your Website Header Banner",
                  type: "header",
                }}
                setImageList={handleImage}
                setImageListRight={handleImageRight}
                onChange={onChangeUrl}
                setTabName={handleTab}
                setGif={handleGif}
              />
              {/* <InputBox
                data={updateForm.destinationURL}
                onChange={async (e) => {
                  e.preventDefault();
                  await handleChange(
                    e.target.value,
                    updateForm.destinationURL.key
                  );
                }}
              /> */}
            </div>
          )}

          {adSpaceType.right && (
            <div className={"abiw__form"}>
              <WebBannerUploader
                data={{
                  title: "Upload Your Website Slider Banner",
                  type: "slider",
                }}
                setImageListRight={handleImageRight}
                onChange={onChangeUrl}
                setTabName={handleTab}
                setLogo={handleLogo}
                setBanner={handleBannerImage}
                setGifRight={handleGifRight}
              />
              {/* <InputBox
                data={updateForm.destinationURL}
                onChange={async (e) => {
                  e.preventDefault();
                  await handleChange(
                    e.target.value,
                    updateForm.destinationURL.key
                  );
                }}
              /> */}
            </div>
          )}
        </div>
        <div className="col-3 abiw-body-right-wrapper">
          <div className="aiw-title">Preview</div>
          {adSpaceType.header && (
            <PreviewAdsImage
              data={{ type: "header" }}
              imageList={previewImages}
            />
          )}
          {adSpaceType.right && (
            <PreviewAdsImage
              data={{ type: "slider" }}
              imageListRight={previewImagesRight}
            />
          )}
          {banner && (
            <PreviewAdsImage
              data={{ type: "banner" }}
              logo={logoImage}
              banner={bannerImage}
              title={updateForm.title.value}
              content={updateForm.description.value}
              btnType={updateForm.buttonType.value}
            />
          )}
        </div>
      </div>

      <div>
        <Button
          data={{
            btnName: "Next",
            buttonType: "primary",
            buttonSize: "lg",
            isLoading: isLoading,
          }}
          onClick={async (e) => {
            const newFormData = { ...formData };
            setIsLoading(true);
            if (!adSpaceType.header && !adSpaceType.right) {
              setSelectBocError(true);
              Store.addNotification({
                title: "Error!",
                message: "Campaign Space Type are required!",
                type: "danger",
                insert: "top",
                container: "top-right",
                dismiss: {
                  duration: 3000,
                  onScreen: true,
                },
              });
              setIsLoading(false);
            }
            if (adSpaceType.header) {
              if (previewImages?.length === 0 && gifImage === null) {
                Store.addNotification({
                  title: "Error!",
                  message: "Campaign Banner images are required!",
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  dismiss: {
                    duration: 3000,
                    onScreen: true,
                  },
                });
                setIsLoading(false);
              }
              if (updateForm.destinationURL.value === "") {
                Store.addNotification({
                  title: "Error!",
                  message: "Campaign Destination URL are required!",
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  dismiss: {
                    duration: 3000,
                    onScreen: true,
                  },
                });
                setIsLoading(false);
                newFormData["destinationURL"].touched = true;
                newFormData["destinationURL"].isValid = true;
                setFormData(newFormData);
              }
            }
            if (adSpaceType.right) {
              if (banner) {
                if (
                  bannerImage === "" &&
                  logoImage === "" &&
                  updateForm.title.value === "" &&
                  updateForm.description.value === "" &&
                  updateForm.buttonType.value === ""
                ) {
                  Store.addNotification({
                    title: "Error!",
                    message: "Campaign Text Banner combo fields are required!",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    dismiss: {
                      duration: 3000,
                      onScreen: true,
                    },
                  });
                  newFormData["title"].touched = true;
                  newFormData["title"].isValid = true;
                  newFormData["description"].touched = true;
                  newFormData["description"].isValid = true;
                  newFormData["buttonType"].touched = true;
                  newFormData["buttonType"].isValid = true;
                  setIsLoading(false);
                }
              }
              if (previewImagesRight?.length === 0 && gifImageRight === null) {
                Store.addNotification({
                  title: "Error!",
                  message: "Campaign Banner images are required!",
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  dismiss: {
                    duration: 3000,
                    onScreen: true,
                  },
                });
                setIsLoading(false);
              }
              if (updateForm.destinationURL.value === "") {
                Store.addNotification({
                  title: "Error!",
                  message: "Campaign Destination URL are required!",
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  dismiss: {
                    duration: 3000,
                    onScreen: true,
                  },
                });
                setIsLoading(false);
                newFormData["destinationURL"].touched = true;
                newFormData["destinationURL"].isValid = true;
                setFormData(newFormData);
              }
            }
            if (advertisement !== "") {
              dispatch(
                setNewAdvertisement({
                  ...advertisement,
                  placement: { home: true, inner: true },
                  ad_space: adSpaceType,
                  header_banner_img: previewImages,
                  right_banner_img: previewImagesRight,
                  text_banner_logo: logoImage,
                  text_banner_img: bannerImage ? [bannerImage] : [],
                  header_gif: gifImage ? [gifImage] : [],
                  right_gif: gifImageRight ? [gifImageRight] : [],
                  title: updateForm.title.value,
                  description: updateForm.description.value,
                  button_type: updateForm.buttonType.value,
                  web_url: updateForm.destinationURL.value,
                  time_schedule: "",
                  start_date: "",
                  end_date: "",
                })
              );
              props.onNext();
              setIsLoading(false);
            } else {
              for (let key in updateForm) {
                newFormData[key].touched = true;
                newFormData[key].isValid = true;
              }
              setFormData(newFormData);
              Store.addNotification({
                title: "Error!",
                message: "Fields are required!",
                type: "danger",
                insert: "top",
                container: "top-right",
                dismiss: {
                  duration: 3000,
                  onScreen: true,
                },
              });
              setIsLoading(false);
            }
          }}
        />
      </div>
    </>
  );
};

export default withRouter(AdvWebImageUploader);
